/*
 * pl-cashback-rende — mantém em dia, no carrinho, a linha "Esta compra rende
 * até R$ X" da caixa de cashback (06/10/2026).
 *
 * POR QUE EXISTE: a linha nasce do Liquid (snippets/pl-cashback-saldo.liquid)
 * com o valor do carregamento. Quando o cliente muda a quantidade, inclui ou
 * tira um item, o tema atualiza os totais na tela sem recarregar a página, e a
 * linha ficaria com o valor antigo: promessa errada.
 *
 * DE ONDE VEM A CONTA: do subtotal que o próprio tema mantém na tela,
 * [data-cart-value="subtotal"], dentro do mesmo <cart-checkout>. Nenhuma
 * requisição nova e nenhuma interferência no carrinho: só leitura. O percentual,
 * o mínimo e os textos vêm dos atributos data-* da linha (ajustes do tema).
 *
 * ARREDONDA PARA BAIXO, em centavos, como o bloco do checkout.
 *
 * NÃO USA requestAnimationFrame: em aba escondida ele não roda (lição do
 * pl-parcela-unica.js). E NÃO compara innerHTML para decidir se reescreve: o
 * navegador devolve o espaço do "R$ 2,02" como &nbsp;, a comparação nunca
 * bateria e o observador entraria em laço. A decisão é pela chave em
 * data-ultimo (atributo não dispara o observador, que só olha filhos e texto).
 */
(function () {
  var agendado = false;

  function centavos(texto) {
    var digitos = String(texto || '').replace(/\D/g, '');
    return digitos ? parseInt(digitos, 10) : 0;
  }

  function dinheiro(valor) {
    var moeda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    try {
      return (valor / 100).toLocaleString((window.Shopify && window.Shopify.locale) || 'pt-BR', { style: 'currency', currency: moeda });
    } catch (e) {
      return 'R$ ' + (valor / 100).toFixed(2).replace('.', ',');
    }
  }

  function escapa(texto) {
    return String(texto || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function atualiza() {
    agendado = false;
    var linhas = document.querySelectorAll('[data-pl-cashback-rende]');
    for (var i = 0; i < linhas.length; i++) {
      var linha = linhas[i];
      var raiz = linha.closest('cart-checkout') || linha.closest('.cart-checkout');
      var fonte = raiz && (raiz.querySelector('[data-cart-value="subtotal"]') || raiz.querySelector('[data-cart-value="total"]'));
      if (!fonte) continue; // sem total na tela, vale o que o Liquid escreveu

      var pct = parseFloat(linha.getAttribute('data-pct')) || 0;
      var minimo = parseInt(linha.getAttribute('data-minimo'), 10) || 0;
      var rende = Math.floor((centavos(fonte.textContent) * pct) / 100 + 1e-9);
      var comValor = rende >= minimo;
      var chave = rende + '|' + comValor;

      if (linha.getAttribute('data-ultimo') !== chave) {
        linha.setAttribute('data-ultimo', chave);
        if (rende > 0) {
          linha.innerHTML = comValor
            ? escapa(linha.getAttribute('data-com-valor')).replace('{valor}', '<strong>' + escapa(dinheiro(rende)) + '</strong>')
            : escapa(linha.getAttribute('data-sem-valor'));
        }
      }

      var esconder = !(rende > 0);
      if (linha.hidden !== esconder) linha.hidden = esconder;

      var caixa = linha.closest('[data-pl-cashback-saldo]');
      if (caixa) {
        var vazia = esconder && !caixa.querySelector('[data-pl-cashback-tem-saldo]');
        if (caixa.hidden !== vazia) caixa.hidden = vazia;
      }
    }
  }

  function agenda() {
    if (agendado) return;
    agendado = true;
    setTimeout(atualiza, 80);
  }

  function liga() {
    var alvos = document.querySelectorAll('.cart-drawer, .cart-page');
    var observador = new MutationObserver(agenda);
    if (!alvos.length) alvos = [document.body];
    for (var i = 0; i < alvos.length; i++) {
      observador.observe(alvos[i], { childList: true, subtree: true, characterData: true });
    }
    agenda();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', liga);
  } else {
    liga();
  }
})();
